export default __webpack_public_path__ + "static/team_1-3c032ff136c64cf6a4dfcded427d628d.png";